import {library} from "@fortawesome/fontawesome-svg-core";
import {fab} from "@fortawesome/free-brands-svg-icons";
import {
  faCalendarAlt,
  faCog,
  faEdit,
  faExclamationTriangle,
  faHome,
  faInfo,
  faNewspaper,
  faUsers,
  faArrowLeft,
  faArrowRight,
  faSort,
  faCheck,
  faCheckCircle,
  faPlus,
  faExclamationCircle,
  faTrash,
  faAlignLeft,
  faCalendarCheck,
  faPencilAlt,
  faCircle,
  faMapMarkerAlt,
  faSignOutAlt,
  faChevronLeft,
  faChevronRight,
  faUser,
  faFlag,
  faQuestionCircle,
  faDotCircle,
  faEllipsisH,
  faEye,
  faBell,
  faCalendarDay,
  faFileExport,
  faCalendarTimes,
  faUserCog,
  faUserPlus,
  faAddressBook,
  faAt,
  faKey,
  faSearch,
  faBook,
  faImage,
  faStar,
  faClock,
  faExchangeAlt
} from "@fortawesome/free-solid-svg-icons";

export const loadIcons = () => {
  library.add(
    fab,
    faHome,
    faNewspaper,
    faCalendarAlt,
    faUsers,
    faCog,
    faExclamationTriangle,
    faInfo,
    faEdit,
    faArrowLeft,
    faArrowRight,
    faSort,
    faCheck,
    faCheckCircle,
    faPlus,
    faExclamationCircle,
    faTrash,
    faAlignLeft,
    faCalendarCheck,
    faPencilAlt,
    faCircle,
    faMapMarkerAlt,
    faSignOutAlt,
    faChevronLeft,
    faChevronRight,
    faUser,
    faFlag,
    faQuestionCircle,
    faDotCircle,
    faEllipsisH,
    faEye,
    faBell,
    faCalendarDay,
    faFileExport,
    faCalendarTimes,
    faUserCog,
    faUserPlus,
    faAddressBook,
    faAt,
    faKey,
    faSearch,
    faBook,
    faImage,
    faStar,
    faClock,
    faExchangeAlt
  );
};
